import styled from 'styled-components';
export const GoogleButtonState = styled.div `
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
export const GoogleSignInButton = styled.button `
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: white;
  background-image: none;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  width: 345px;
  height: 54px;
  border-radius: 10px;

  box-shadow: 0px 2px 10px 1px #0000002b;
  border: none;

  &:disabled {
    cursor: default;
    background-color: #ffffff61;
    border-color: #1f1f1f1f;
  }

  &:not(:disabled):active ${GoogleButtonState}, &:not(:disabled):focus ${GoogleButtonState} {
    background-color: #303030;
    opacity: 12%;
  }

  &:not(:disabled):hover ${GoogleButtonState} {
    background-color: #303030;
    opacity: 8%;
  }

  @media screen and (max-width: 470px) {
    width: 100%;
    height: 48px;
  }
`;
export const GoogleButtonIcon = styled.div `
  height: 24px;
  margin-right: 15px;
  width: 24px;

  ${GoogleSignInButton}:disabled & {
    opacity: 38%;
  }
`;
export const GoogleButtonContentWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  padding: 0 15px;
`;
export const GoogleButtonContents = styled.span `
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  font-size: 20px;
  overflow: hidden;
  color: #0000008a;
  max-width: fit-content;

  ${GoogleSignInButton}:disabled & {
    opacity: 38%;
  }

  @media screen and (max-width: 470px) {
    font-size: 18px;
  }
`;
